import storeManager from '../store/StoreManager';
import assessmentReader from '../store/readHelpers/AssessmentReader';
import assessmentActions from '../actions/AssessmentActions';

const assessmentService = {
    replaceQuestionsInAssessment(clonedOriginalAssessment, catAssessment) {
        const originalSections = clonedOriginalAssessment.sections;
        const catSections = catAssessment.sections;
        const state = storeManager.getState();
        const { currentlyShown } = state;
        const currentlyShownQuestion = assessmentReader.getQuestion(currentlyShown.questionId);

        if (catSections.length === 1) {
            const originalSection = originalSections[0];
            const catSection = catSections[0];

            if (this.canQuestionsInSectionBeReplaced(catSection, currentlyShownQuestion, originalSection)) {
                clonedOriginalAssessment.sections[0].questions = this.getMergedQuestions(catSection, currentlyShownQuestion, originalSection);
                return clonedOriginalAssessment;
            }
            return false;
        }
        const currentlyShownSectionIndex = assessmentReader.getCurrentShownSectionIndex();
        if (currentlyShownSectionIndex) {
            if (this.canSectionsQuestionsBeReplaced(currentlyShownSectionIndex, originalSections, catSections)) {
                clonedOriginalAssessment.sections = this.getMergedSectionsQuestions(originalSections, catSections, currentlyShownSectionIndex);
                return clonedOriginalAssessment;
            }
        }
        return false;
    },

    canQuestionsInSectionBeReplaced(catSection, currentShownQuestion, originalSection) {
        if (currentShownQuestion && catSection) {
            const areAllSecQuestionsInCatSection = this.areAllSectionAnsweredQuestionsInCatSection(originalSection.questions,
                currentShownQuestion, catSection.questions);
            if (areAllSecQuestionsInCatSection) {
                return true;
            }
            console.warn('areAllSecQuestionsInCatSection is false');
        }
        console.warn('canQuestionsInSectionBeReplaced is false');
        return false;
    },

    getMergedQuestions(catSection, currentlyShownQuestion, originalSection) {
        return [
            ...originalSection.questions
                .filter(question => question.questionNumberInQuestionSet <= currentlyShownQuestion.questionNumberInQuestionSet),
            ...catSection.questions.filter(
                question => question.questionNumberInQuestionSet > currentlyShownQuestion.questionNumberInQuestionSet),
        ];
    },

    areAllSectionAnsweredQuestionsInCatSection(originalSectionQuestions, currentShownQuestion, catSectionQuestions) {
        const originalQuestions = originalSectionQuestions.filter(this.isBeforeCurrentlyShowQuestionNumber(currentShownQuestion));

        return originalQuestions.every((question) => {
            const questionInCat = catSectionQuestions.find(this.isQuestionInCatSection(question));
            if (!questionInCat) {
                console.warn(`questionId ${question.contentRevisionId} is not in cat section`);
                return false;
            }
            return true;
        });
    },

    isBeforeCurrentlyShowQuestionNumber(currentShownQuestion) {
        return originalQuestion => originalQuestion.questionNumberInQuestionSet <= currentShownQuestion.questionNumberInQuestionSet;
    },

    isQuestionInCatSection(question) {
        return catQuestion => catQuestion.contentRevisionId === question.contentRevisionId
            && catQuestion.questionNumberInQuestionSet === question.questionNumberInQuestionSet;
    },

    canSectionsQuestionsBeReplaced(currentlyShownSectionIndex, currentAssessmentSections, catAssessmentSections) {
        const originalSections = currentAssessmentSections.slice(0, currentlyShownSectionIndex + 1);
        const catSections = catAssessmentSections.slice(0, currentlyShownSectionIndex + 1);
        const sectionsArraysMatch = this.sectionsArraysMatch(originalSections, catSections);
        if (!sectionsArraysMatch) {
            console.warn(`sectionsArraysMatch: ${sectionsArraysMatch}`);
            return false;
        }
        return true;
    },

    sectionsArraysMatch(originalSections, catSections) {
        return originalSections.every((section, sectionIndex) => {
            const catSection = catSections[sectionIndex];
            const sectionIdsMatch = section.id === catSection.id;
            if (!sectionIdsMatch) {
                console.warn(
                    `originalSectionId ${section.id} does not match ${catSection.id} in same sectionIndex: ${sectionIndex}`
                );
                return false;
            }
            return true;
        });
    },

    getMergedSectionsQuestions(originalSections, catSections, currentlyShownSectionIndex) {
        return [
            ...originalSections.slice(0, currentlyShownSectionIndex + 1),
            ...catSections.slice(currentlyShownSectionIndex + 1),
        ];
    },

    populateDummyQuestionSet(initialQS = {}) {
        const assessment = { sections: [], ...initialQS };
        storeManager.dispatch(assessmentActions.setAssessmentState(assessment));
    },

    setAllQuestionsAsNotParsed() {
        storeManager.dispatch(assessmentActions.setAllQuestionsAsNotParsed());
    },

    mapContentRevisionIdToContentId(contentRevisionId, assessment) {
        if (!assessment) {
            return -1;
        }

        const sections = assessment.mergedSections ? assessment.mergedSections : assessment.sections;
        const question = sections?.reduce(
            (allQuestions, currentSection) => [...allQuestions, ...currentSection.questions],
            []
        ).find(question => question.contentRevisionId === contentRevisionId);

        return question ? question.contentItemId : -1;
    },
};

export default assessmentService;
